import React from "react";

const Programs = () => {
  return (
    <div>
      <h1>Programs</h1>
      <p>Welcome to the Programs page.</p>
    </div>
  );
};

export default Programs;
